import Location from 'react-app-location';

export const OpenRequestsLocation = new Location('/requests/open');
